import { Card } from '@wartek-id/card'

import StateError from 'app/KinerjaShared/components/StateError'

import type { FC } from 'react'

interface CardStateErrorProps {
  onClick?: () => void
}

const CardStateError: FC<CardStateErrorProps> = ({ onClick }) => {
  return (
    <Card className="p-9">
      <StateError onClick={onClick} />
    </Card>
  )
}
export default CardStateError
